import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PrestataireCard from "../PrestataireCard";

export default function GestionPrestatairesToValidate() {
  const [prestataires, setPrestataires] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const apiUrl = process.env.REACT_APP_API_URL;
  const { token } = useSelector((state) => state.auth);

  // --- Charger les prestataires ---
  const fetchPrestataires = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${apiUrl}/api/verif`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Erreur lors du chargement");
      setPrestataires(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrestataires();
  }, []);

  // --- Valider un prestataire ---
  const handleValidate = async (idPrestataire) => {
    if (!window.confirm("Confirmer la validation du prestataire ?")) return;

    try {
      const res = await fetch(`${apiUrl}/api/verif`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ idPrestataire }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Erreur lors de la validation");

      alert(data.success || "Prestataire validé avec succès");

      // passer au suivant
      setCurrentIndex((prev) => prev + 1);
    } catch (err) {
      alert(err.message);
    }
  };

  if (loading) return <p>Chargement...</p>;
  if (error) return <p style={{ color: "red" }}>Erreur : {error}</p>;
  if (prestataires.length === 0 || currentIndex >= prestataires.length)
    return <p>Aucun prestataire à valider 🎉</p>;

  const prestataire = prestataires[currentIndex];

  return (
    <PrestataireCard
      prestataire={prestataire}
      apiUrl={apiUrl}
      onValidate={handleValidate}
      onSkip={() => setCurrentIndex((prev) => prev + 1)}
    />
  );
}
